enum NotificationType {
    MbiVerification,
    ApplicationSuccess,
    ApplicationSuccessMbiVerificationRequired,
}

export default NotificationType;
